import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "app-toggle-checkbox",
  templateUrl: "./toggle-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./toggle-checkbox.component.scss"]
})
export class ToggleCheckboxComponent implements OnInit {
  @Output() toggled: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
